module.exports = __webpack_public_path__ + "static/img/260119_EN_Organization.397c0f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/260119_EN_Organization.jpg
// module id = bDI6
// module chunks = 1